enum SphereNavigationRoutes {
  Dashboard = '/',
  Users = '/users',
  Organizations = '/organizations',
  Administration = '/administration',
  Statistics = '/statistics',
  MissionHistory = '/mission-history',
  Report = '/report',
  Settings = '/settings',

  Register = '/register',
  Unsubscribe = '/unsubscribe',

  Insights = '/insights',
  InsightsDatasets = '/insights/datasets',

  Legal = '/legal',
  AccountData = '/account-data',
}

export default SphereNavigationRoutes
